<template>
    <div style="background-color: #eeeeee; padding: 10px;">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <div class="modal-header">
                            <slot name="header">
                                <h3>Activity Details</h3>
                            </slot>
                        </div>

                        <div class="modal-body">
                            <slot name="body">
                                <div v-for="data in activityMeta.meta.data">
                                    <div v-if="data.key == 'meta' && data.value == 'data'">
                                        <table class="table table-striped">
                                            <thead>
                                            <tr>
                                                <th>Field</th>
                                                <th>Value</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(value, key) in data.meta" v-if="key != 'formID' && key != 'ip' && key != 'submission_id' && key != 'vessel-id' && key != 'campaign-id' && key != 'step-id' && key != 'target-step-id' && key != 'vessel_id' && key != 'campaign_id' && key != 'step_id'">
                                                <td><b>{{key}}</b></td>
                                                <td>{{value}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </slot>
                        </div>

                        <div class="modal-footer">
                            <slot name="footer">
                                <button class="modal-default-button" @click="$emit('close')">
                                    Close
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'modal',
        props: {
            activityMeta: {
                required: true,
                type: Object
            },
            showModal: {
                required: true,
                type: Boolean
            }
        }
    }
</script>
